var lists_default = {
  "fontElementMap": "_90whb",
  "orderedlist": "xD-Fd",
  "bulletedlist": "C4pYk",
  "listItem": "VP-ko"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
